import { Component, computed, input } from '@angular/core';
import type { EmptyStateHeadingLevel, EmptyStateVariant } from './empty-state.types';

@Component({
  selector: 'app-empty-state',
  templateUrl: './empty-state.component.html',
  styleUrls: ['./empty-state.component.css'],
})
export class EmptyStateComponent {
  readonly heading = input<string>('Sem dados para exibir');
  readonly subtitle = input<string>('');
  readonly variant = input<EmptyStateVariant>('plain');

  readonly headingLevel = input<EmptyStateHeadingLevel>(2);

  protected readonly isBoxed = computed(() => this.variant() === 'boxed');

  protected readonly showsArt = computed(() => this.variant() !== 'bare');
}
